import React from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  Share,
  WysiwygField,
  Hero,
} from '../../../../components';

import NewsletterBlock from '../../../../components/NewsletterBlock';

import './style.scss';

interface PartnerDetailProps {
  entity: ImmutableEntity<any>;
  className?: string;
}

const PartnerDetail: React.FC<PartnerDetailProps> = ({ entity, className }) => {
  const classes = classNames(className, 'NodePartnerDetail');

  const title = entity.getIn(['title', 0, 'value'], '');
  const subtitle = entity.getIn(['field_subtitle', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed']);
  const paragraphs = entity.getIn(['field_paragraphs'], Immutable.Map());

  return (
    <article typeof="schema:WebPage" className={classes}>
      <Hero />
      <Container>
        <div className="NodePartnerDetail__content__wrapper row">
          <div className="col-12 col-lg-10 offset-lg-1">
            <div className="NodePartnerDetail__content" id="main">
              <h1>{title}</h1>

              {subtitle && (
                <div className="NodePartnerDetail__content__subtitle">
                  {subtitle}
                </div>
              )}

              {body && (
                <WysiwygField
                  property="schema:text"
                  className="NodeArticleDetail__body subheading2"
                  html={body}
                />
              )}
            </div>
          </div>
        </div>
      </Container>
      <div className="NodeContentWrapper">

        {paragraphs.size > 0 && (
          <div className="Paragraphs">
            {
              paragraphs.map((item: any, index: number) => {
                const paragraphId = item.get('target_id');
                const paragraph = item.getIn(['entity']);

                return (
                  <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} />
                );
              })
            }
          </div>
        )}

        <Container>
          <div className="row">
            <div className="col-12 col-lg-8 offset-lg-2">
              <Share pageTitle={entity.getIn(['title', 0, 'value'], '')} />
            </div>
          </div>
        </Container>
      </div>

      {/* Newsletter subscription block */}
      <NewsletterBlock />
    </article>
  );
};


export default PartnerDetail;
